const config = require("../config.js");
const UTILS = require("../libs/utils.js");
const GEOS = require("../libs/geos.js");
const itemTypes = require("./itemTypes.js");
var weapons;
var store;
module.exports = function (p5102) {
  var vThis31 = this;
  if (p5102) {
    weapons = require("./weapons.js");
    store = require("./store.js");
  }
  this.textures = [{
    alias: "Stone",
    name: "WALL",
    src: "wall_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Classic",
      id: 1
    }, {
      name: "Light",
      id: 2
    }, {
      name: "Voxel",
      id: 3
    }, {
      name: "Pebbles",
      id: 4
    }, {
      name: "Cobble",
      id: 5
    }, {
      name: "Light Pebbles",
      id: 6
    }, {
      name: "Light Cobble",
      id: 7
    }]
  }, {
    name: "DIRT",
    src: "dirt_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Classic",
      id: 1
    }, {
      name: "Voxel",
      id: 2
    }, {
      name: "Modern",
      id: 3
    }]
  }, {
    alias: "Wood",
    name: "FLOOR",
    src: "floor_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Classic",
      id: 1
    }, {
      name: "Classic Alt",
      id: 2
    }, {
      name: "Modern",
      id: 3
    }]
  }, {
    name: "GRID",
    src: "grid_0"
  }, {
    name: "GREY",
    src: "grey_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Template",
      id: 1
    }, {
      name: "Modern",
      id: 2
    }]
  }, {
    alias: "None",
    name: "DEFAULT",
    src: "default"
  }, {
    name: "ROOF",
    src: "roof_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Classic",
      id: 1
    }, {
      name: "Tiled",
      id: 2
    }]
  }, {
    name: "FLAG",
    src: "flag_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Classic",
      id: 1
    }, {
      name: "Classic Alt",
      id: 2
    }]
  }, {
    name: "GRASS",
    src: "grass_1",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Voxel",
      id: 1
    }, {
      name: "Simple",
      id: 2
    }, {
      name: "Dense",
      id: 3
    }]
  }, {
    name: "CHECK",
    src: "check_0"
  }, {
    name: "LINES",
    src: "lines_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Thick",
      id: 1
    }, {
      name: "Pipes",
      id: 2
    }]
  }, {
    name: "BRICK",
    src: "brick_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Classic",
      id: 1
    }, {
      name: "Classic Alt",
      id: 2
    }, {
      name: "Dark",
      id: 3
    }, {
      name: "Light",
      id: 4
    }, {
      name: "Simple Red",
      id: 5
    }, {
      name: "Patterned Red",
      id: 6
    }, {
      name: "Simple Dark",
      id: 7
    }, {
      name: "Patterned Dark",
      id: 8
    }, {
      name: "Simple Light",
      id: 9
    }, {
      name: "Patterned Light",
      id: 10
    }]
  }, {
    name: "LINK",
    src: "link_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Type 2",
      id: 1
    }, {
      name: "Type 3",
      id: 2
    }],
    trans: true
  }, {
    name: "LIQUID",
    src: "liquid_0",
    variants: [{
      name: "Water",
      id: 0
    }, {
      name: "Voxel Water",
      id: 1
    }, {
      name: "Lava",
      id: 2
    }, {
      name: "Greek Water",
      id: 3
    }],
    trans: true
  }, {
    name: "GRAIN",
    src: "grain_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Type 2",
      id: 1
    }, {
      name: "Type 3",
      id: 2
    }]
  }, {
    name: "FABRIC",
    src: "fabric_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Type 2",
      id: 1
    }, {
      name: "Type 3",
      id: 2
    }, {
      name: "Type 4",
      id: 3
    }]
  }, {
    name: "TILE",
    src: "tile_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Light",
      id: 1
    }, {
      name: "Modern",
      id: 2
    }, {
      name: "Beveled",
      id: 3
    }]
  }, {
    name: "METAL",
    src: "metal_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Brick",
      id: 1
    }]
  }, {
    name: "SAND",
    src: "sand_0",
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Voxel",
      id: 1
    }, {
      name: "Greek",
      id: 2
    }]
  }, {
    name: "SNOW",
    src: "snow_0"
  }];
  this.getTextureIdByName = function (p5103) {
    p5103 = p5103.toUpperCase();
    for (var vLN0714 = 0; vLN0714 < this.textures.length; vLN0714++) {
      if (this.textures[vLN0714].name == p5103) {
        return vLN0714;
      }
    }
    return 0;
  };
  this.getTextureIdBySrc = function (p5104) {
    p5104 = p5104.toLowerCase();
    for (var vLN0715 = 0; vLN0715 < this.textures.length; vLN0715++) {
      if (this.textures[vLN0715].src == p5104) {
        return vLN0715;
      }
    }
    return 0;
  };
  this.getTextureByName = function (p5105) {
    p5105 = (p5105 || "").toUpperCase();
    for (var vLN0716 = 0; vLN0716 < this.textures.length; vLN0716++) {
      if (this.textures[vLN0716].name == p5105) {
        return this.textures[vLN0716];
      }
    }
    return null;
  };
  this.textureExist = function (p5106) {
    p5106 = (p5106 || "").toUpperCase();
    for (var vLN0717 = 0; vLN0717 < this.textures.length; vLN0717++) {
      if (this.textures[vLN0717].name == p5106) {
        return true;
      }
    }
    return false;
  };
  this.prefabs = [{
    name: "CUBE",
    src: "cube_0",
    genGeo: async (p5107, p5108) => vThis31.generateCube(p5107, p5108),
    editFaces: true,
    editFog: true,
    movingTexture: true,
    frameTexture: true,
    defaultSize: [10, 10, 10],
    hasHealth: true,
    scalable: true,
    editAmb: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    editPen: true,
    editBulletCol: true,
    editAICol: true,
    texturable: true,
    assetTextures: true,
    castShadow: true,
    receiveShadow: true,
    hasBorder: true,
    canInterface: true,
    canStretch: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    canTrans: true,
    stepSrc: true,
    canComplexColl: true,
    editRenderSide: true,
    showMinimap: true,
    canDirectionalScale: true
  }, {
    name: "CRATE",
    src: "crate_0",
    scale: 6,
    isProp: true,
    gen: p5109 => vThis31.loadObj(p5109, "models/crate_0.obj", "textures/crate_0.png", p5109.mSize || this.scale, p5109.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Minimalistic",
      id: 1
    }, {
      name: "Classic 2018",
      id: 2,
      diffM: true
    }, {
      name: "Supply",
      id: 3,
      diffM: true
    }, {
      name: "Dusty",
      id: 4,
      diffM: true
    }]
  }, {
    name: "BARREL",
    src: "barrel_0",
    scale: 4,
    mlt: 1,
    isProp: true,
    CP: -1,
    gen: p5110 => vThis31.loadObj(p5110, "models/barrel_0.obj", "textures/barrel_0.png", p5110.mSize || this.scale, p5110.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Classic 2018",
      id: 1,
      diffM: true,
      complex: true
    }, {
      name: "Classic 2018 Alt",
      id: 2,
      diffM: true,
      complex: true
    }, {
      name: "Classic 2019",
      id: 3,
      diffM: true,
      complex: true
    }, {
      name: "Krum",
      id: 4,
      diffM: true,
      complex: true
    }, {
      name: "Supply",
      id: 5,
      diffM: true,
      complex: true
    }]
  }, {
    name: "LADDER",
    src: "cube_0",
    scale: 0.5,
    width: 3.2,
    genGeo: async p5111 => vThis31.generateLadder(p5111, p5111.direction),
    notTechnical: true,
    defaultSize: [2, 10, 4],
    scalable: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    hideBoundingBox: false,
    editOpac: true,
    texturable: true,
    assetTextures: true,
    customDirection: true,
    castShadow: true,
    receiveShadow: true,
    canStretch: true,
    canTrans: true,
    stepSrc: true,
    canDirectionalScale: true
  }, {
    name: "PLANE",
    src: "cube_0",
    genGeo: async p5112 => vThis31.generatePlane(p5112, p5112.size[0], p5112.size[2]),
    hasHealth: true,
    defaultSize: [4, 0.01, 4],
    movingTexture: true,
    frameTexture: true,
    dontRound: true,
    scalable: true,
    canTerrain: true,
    edgeNoise: true,
    scaleWithSize: true,
    editColor: true,
    editPen: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    texturable: true,
    assetTextures: true,
    castShadow: true,
    receiveShadow: true,
    doubleSide: true,
    canInterface: true,
    canStretch: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    canTrans: true,
    canSprite: true,
    stepSrc: true,
    editFog: true,
    editAlphaTest: true,
    canComplexColl: true,
    showMinimap: true,
    canDirectionalScale: true
  }, {
    name: "SPAWN_POINT",
    src: "cube_0",
    genGeo: async (p5113, p5114) => vThis31.generateSpawn(p5113, p5114),
    notTechnical: true,
    notStyleable: true,
    scalable: false,
    alwaysSee: true,
    tool: true,
    scaleWithSize: false,
    teamable: true,
    noTexture: true,
    opacity: 0.00001,
    customDirection: true,
    dontRound: true,
    zone: true
  }, {
    name: "CAMERA_POSITION",
    src: "cube_0",
    editorGen: p5115 => vThis31.generateSprite(p5115, "img/crosshair.png", 5),
    notTechnical: true,
    notStyleable: true,
    defaultSize: [2, 2, 2],
    scalable: false,
    isCam: true,
    alwaysSee: true,
    tool: true,
    scaleWithSize: false
  }, {
    name: "VEHICLE",
    src: "vehicle_0",
    scale: 20,
    gen: p5116 => vThis31.loadObj(p5116, "models/vehicle_0.obj", "textures/vehicle_0.png", p5116.mSize || this.scale, p5116.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    complex: true,
    emiss: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Classic 2018",
      id: 1
    }, {
      name: "Blue Ute",
      id: 2,
      diffM: true
    }, {
      name: "Red Sedan",
      id: 3,
      diffM: true
    }]
  }, {
    name: "STACK",
    src: "stack_0",
    scale: 6,
    isProp: true,
    gen: p5117 => vThis31.loadObj(p5117, "models/stack_0.obj", "textures/stack_0.png", p5117.mSize || this.scale, p5117.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true
  }, {
    name: "RAMP",
    src: "cube_0",
    genGeo: async p5118 => vThis31.generateRamp(p5118, p5118.direction),
    notTechnical: true,
    defaultSize: [10, 5, 10],
    movingTexture: true,
    frameTexture: true,
    scalable: true,
    scaleWithSize: false,
    hideBoundingBox: false,
    boostable: true,
    editColor: true,
    editEmissive: true,
    texturable: true,
    assetTextures: true,
    shootable: true,
    customDirection: true,
    castShadow: true,
    receiveShadow: true,
    doubleSide: true,
    editOpac: true,
    canStretch: true,
    editAICol: true,
    canTrans: true,
    stepSrc: true,
    noRotation: true,
    showMinimap: true,
    canDirectionalScale: true
  }, {
    name: "SCORE_ZONE",
    src: "cube_0",
    genGeo: async (p5119, p5120) => vThis31.generateCube(p5119, p5120),
    notStyleable: true,
    customScore: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 16776960,
    tool: true,
    zone: true,
    canDirectionalScale: true
  }, {
    name: "BILLBOARD",
    src: "cube_0",
    genGeo: async p5121 => vThis31.generateBillboard(0, 0, 0, ...p5121.size),
    hasHealth: true,
    defaultSize: [40, 0.01, 20],
    lineCol: 16776960,
    dontRound: true,
    scalable: true,
    canTerrain: true,
    scaleWithSize: true,
    hideBoundingBox: false,
    castShadow: true,
    receiveShadow: true,
    doubleSide: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    canSprite: true,
    editFog: true,
    canDirectionalScale: true
  }, {
    name: "DEATH_ZONE",
    src: "cube_0",
    genGeo: async (p5122, p5123) => vThis31.generateCube(p5122, p5123),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 16711680,
    tool: true,
    zone: true,
    forceCollision: true,
    hasHealth: true,
    canInterface: true,
    canDirectionalScale: true
  }, {
    name: "PARTICLES",
    src: "cube_0",
    genGeo: async (p5124, p5125) => vThis31.generateCube(p5124, p5125),
    customDirection: true,
    notTechnical: true,
    defaultSize: [20, 20, 20],
    editColor: true,
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 3080191,
    tool: true,
    canDirectionalScale: true
  }, {
    name: "OBJECTIVE",
    src: "cube_0",
    genGeo: async (p5126, p5127) => vThis31.generateObjective(p5126, p5127),
    canSetObjective: true,
    notTechnical: true,
    notStyleable: true,
    defaultSize: [50, 50, 50],
    scalable: true,
    doubleSide: true,
    lineCol: 13107455,
    tool: true,
    zone: true,
    doubleSide: true,
    canDirectionalScale: true
  }, {
    name: "TREE",
    src: "tree_0",
    scale: 10,
    gen: p5128 => vThis31.loadObj(p5128, "models/tree_0.obj", "textures/tree_0.png", p5128.mSize || this.scale, p5128.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    complex: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Classic",
      id: 1,
      diffM: true
    }, {
      name: "Palm",
      id: 2,
      diffM: true
    }, {
      name: "Dead",
      id: 3,
      diffM: true
    }, {
      name: "Snowy Pine",
      id: 4,
      diffM: true
    }, {
      name: "Poly",
      id: 5,
      diffM: true
    }, {
      name: "Jungle",
      id: 6,
      diffM: true
    }, {
      name: "Pine",
      id: 7,
      diffM: true
    }, {
      name: "HD Poly",
      id: 8,
      diffM: true
    }]
  }, {
    name: "CONE",
    src: "cone_0",
    scale: 4,
    isProp: true,
    CPY: -0.5,
    CP: -2,
    gen: p5129 => vThis31.loadObj(p5129, "models/cone_0.obj", "textures/cone_0.png", p5129.mSize || this.scale, p5129.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    complex: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true,
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Modern",
      id: 1,
      diffM: true
    }]
  }, {
    name: "CONTAINER",
    src: "container_0",
    scale: 7,
    gen: p5130 => vThis31.loadObj(p5130, "models/container_0.obj", "textures/container_0.png", p5130.mSize || this.scale, p5130.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true
  }, {
    name: "GRASS",
    src: "grass_0",
    scale: 32,
    gen: p5131 => vThis31.loadObj(p5131, "models/grass_0.obj", "textures/grass_0.png", p5131.mSize || this.scale, p5131.color, "mesh"),
    hasHealth: true,
    noDetail: true,
    editColor: true,
    editOpac: true,
    complex: true,
    doubleSide: true,
    transparent: true,
    receiveShadow: true,
    canInterface: true,
    frameT: 180,
    frames: 4,
    alphaTest: 0.02,
    noMinimap: true
  }, {
    name: "CONTAINERR",
    src: "containerr_0",
    scale: 7,
    gen: p5132 => vThis31.loadObj(p5132, "models/containerr_0.obj", "textures/containerr_0.png", p5132.mSize || this.scale, p5132.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true
  }, {
    name: "ACIDBARREL",
    src: "acidbarrel_0",
    scale: 4,
    isProp: true,
    gen: p5133 => vThis31.loadObj(p5133, "models/acidbarrel_0.obj", "textures/acidbarrel_0.png", p5133.mSize || this.scale, p5133.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    emiss: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "HD",
      id: 1,
      diffM: true,
      noEmis: true,
      complex: true
    }]
  }, {
    name: "DOOR",
    src: "door_0",
    scale: 5,
    gen: p5134 => vThis31.loadObj(p5134, "models/door_0.obj", "textures/door_0.png", p5134.mSize || this.scale, p5134.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true,
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Modern",
      id: 1,
      diffM: true
    }, {
      name: "Modern Grated",
      id: 2,
      diffM: true
    }, {
      name: "Modern Metal",
      id: 3,
      diffM: true
    }]
  }, {
    name: "WINDOW",
    src: "window_0",
    scale: 6,
    gen: p5135 => vThis31.loadObj(p5135, "models/window_0.obj", "textures/window_0.png", p5135.mSize || this.scale, p5135.color, "mesh"),
    noDetail: true,
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    transparent: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true,
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Modern",
      id: 1,
      diffM: true
    }, {
      name: "Wood Red",
      id: 2,
      diffM: true
    }, {
      name: "Wood Blue",
      id: 3,
      diffM: true
    }, {
      name: "Wood with Awning",
      id: 4,
      diffM: true
    }, {
      name: "Metal",
      id: 5,
      diffM: true
    }, {
      name: "Mosque",
      id: 6,
      diffM: true
    }]
  }, {
    name: "FLAG",
    src: "cube_0",
    genGeo: async (p5136, p5137) => vThis31.generateFlag(p5136, p5137),
    notTechnical: true,
    notStyleable: true,
    noDetail: true,
    defaultSize: [config.flagZoneS, config.flagZoneH, config.flagZoneS],
    scalable: false,
    tool: true,
    scaleWithSize: false,
    lineCol: 13107455,
    teamable: true,
    noDefault: true,
    canNeutral: true,
    canDirectionalScale: true
  }, {
    name: "GATE",
    src: "cube_0",
    genGeo: async (p5138, p5139) => vThis31.generateCube(p5138, p5139),
    editFaces: true,
    editFog: true,
    canUndo: true,
    interact: true,
    customScore: true,
    movingTexture: true,
    frameTexture: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    forceCollision: true,
    editAmb: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    teamable: true,
    lineCol: 16711935,
    texturable: true,
    assetTextures: true,
    tool2: true,
    castShadow: true,
    receiveShadow: true,
    hasBorder: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    canTrans: true,
    canStretch: true,
    interactMsg: true,
    stepSrc: true,
    showMinimap: true,
    canDirectionalScale: true
  }, {
    name: "CHECK_POINT",
    src: "cube_0",
    genGeo: async (p5140, p5141) => vThis31.generateCube(p5140, p5141),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    teamable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 252613,
    tool: true,
    customDirection: true,
    zone: true,
    canDirectionalScale: true
  }, {
    name: "WEAPON_PICKUP",
    src: "cube_0",
    genGeo: async (p5142, p5143) => vThis31.generateWeapon(p5142, p5143),
    notStyleable: true,
    interact: true,
    customScore: true,
    teamable: true,
    defaultSize: [config.pickupZoneX, config.pickupZoneH, config.pickupZoneZ],
    scalable: false,
    tool: true,
    scaleWithSize: false,
    lineCol: 3595263,
    noTexture: true,
    texturable: false,
    opacity: 0.1,
    interactMsg: true
  }, {
    name: "TELEPORTER",
    src: "cube_0",
    genGeo: async (p5144, p5145) => vThis31.generateCube(p5144, p5145),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    teamable: true,
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 11665392,
    tool: true,
    customDirection: true,
    optionalDirection: true,
    zone: true,
    canDirectionalScale: true
  }, {
    name: "TEDDY",
    src: "teddy_0",
    scale: 6,
    isProp: true,
    CPY: -3,
    CP: -3.6,
    gen: p5146 => vThis31.loadObj(p5146, "models/teddy_0.obj", "textures/teddy_0.png", p5146.mSize || this.scale, p5146.color, "mesh"),
    hasHealth: true,
    noDetail: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    complex: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true
  }, {
    name: "TRIGGER",
    src: "cube_0",
    editFaces: true,
    editFog: true,
    canTargetInterface: true,
    hasHealth: true,
    movingTexture: true,
    frameTexture: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    forceCollision: true,
    editAmb: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    teamable: true,
    lineCol: 16711935,
    texturable: true,
    assetTextures: true,
    tool2: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    canTrans: true,
    canStretch: true,
    dontRound: true,
    complex: true,
    hasSpin: true,
    hasSpinDir: true,
    canScript: true,
    alterHitbox: true,
    genGeo: async (p5147, p5148) => vThis31.generateCube(p5147, p5148),
    scale: 1,
    gen: p5149 => vThis31[(p5149.assetID || "").includes("g") || (p5149.assetID || "").includes("q") || (p5149.assetID || "").includes("f") ? "loadAnimObj" : "loadObj"](p5149, "model.obj", "model.png", p5149.mSize || this.scale, p5149.color, "mesh"),
    stepSrc: true,
    editRenderSide: true,
    editAlphaTest: true,
    showMinimap: true,
    canDirectionalScale: true
  }, {
    name: "SIGN",
    src: "cube_0",
    noCol: true,
    genGeo: async p5150 => vThis31.generateSign(p5150, 0, 0, 0, ...p5150.size),
    notTechnical: true,
    movingTexture: true,
    hasText: true,
    defaultSize: [40, 0.01, 10],
    forceCollision: true,
    lineCol: 16776960,
    scalable: true,
    scaleWithSize: true,
    hideBoundingBox: false,
    tool: true,
    castShadow: true,
    receiveShadow: true,
    doubleSide: true,
    canSprite: true,
    canDirectionalScale: true
  }, {
    name: "DEPOSIT_BOX",
    src: "cube_0",
    genGeo: async (p5151, p5152) => vThis31.generateCube(p5151, p5152),
    editFaces: true,
    editFog: true,
    movingTexture: true,
    frameTexture: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    forceCollision: true,
    editAmb: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    teamable: true,
    lineCol: 16711935,
    texturable: true,
    assetTextures: true,
    tool2: true,
    castShadow: true,
    receiveShadow: true,
    hasBorder: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    canTrans: true,
    canStretch: true,
    interactMsg: true,
    stepSrc: true,
    showMinimap: true,
    canDirectionalScale: true
  }, {
    name: "LIGHT_CONE",
    src: "cube_0",
    noCol: true,
    edCat: "lights",
    genGeo: async (p5153, p5154) => vThis31.generateCone(p5153, p5154),
    notTechnical: true,
    defaultSize: [10, 10, 10],
    movingTexture: true,
    noDetail: true,
    scalable: true,
    noCollision: true,
    scaleWithSize: false,
    editOpac: true,
    editColor: true,
    lineCol: 16711935,
    castShadow: true,
    receiveShadow: true,
    complex: true,
    doubleSide: true,
    blending: 2,
    transparent: true,
    canDirectionalScale: true
  }, {
    name: "CAMERA",
    src: "cube_0",
    genGeo: async (p5155, p5156) => vThis31.generateCube(p5155, p5156),
    objectiveLink: true,
    isCam: true,
    notTechnical: true,
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: false,
    tool: true,
    scaleWithSize: false
  }, {
    name: "SPHERE",
    src: "cube_0",
    noCol: true,
    genGeo: async (p5157, p5158) => vThis31.generateSphere(...p5157.size, p5158),
    editFog: true,
    notTechnical: true,
    movingTexture: true,
    frameTexture: true,
    defaultSize: [5, 5, 5],
    scalable: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    noCollision: true,
    texturable: true,
    assetTextures: true,
    canTrans: true,
    canComplexColl: true,
    canDirectionalScale: true
  }, {
    name: "PLACEHOLDER",
    src: "cube_0",
    genGeo: async (p5159, p5160) => vThis31.generateCube(p5159, p5160),
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    noExport: true,
    tool: true,
    opacity: 0.1,
    lineCol: 0
  }, {
    name: "CARDB",
    src: "cardb_0",
    scale: 5,
    isProp: true,
    CPY: -2.5,
    CP: -2,
    gen: p5161 => vThis31.loadObj(p5161, "models/cardb_0.obj", "textures/cardb_0.png", p5161.mSize || this.scale, p5161.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true
  }, {
    name: "PALLET",
    src: "pallet_0",
    scale: 6,
    isProp: true,
    CPY: -5,
    gen: p5162 => vThis31.loadObj(p5162, "models/pallet_0.obj", "textures/pallet_0.png", p5162.mSize || this.scale, p5162.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    complex: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true
  }, {
    name: "LIQUID",
    src: "cube_0",
    noCol: true,
    genGeo: async p5163 => vThis31.generateLiquid(p5163, p5163.size[0], p5163.size[2]),
    noCollision: true,
    notTechnical: true,
    defaultSize: [25, 0.01, 25],
    movingTexture: true,
    dontRound: true,
    scalable: true,
    canTerrain: true,
    scaleWithSize: true,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    texturable: true,
    assetTextures: true,
    castShadow: true,
    receiveShadow: true,
    doubleSide: true,
    canDirectionalScale: true
  }, {
    name: "SOUND_EMITTER",
    src: "cube_0",
    noCol: true,
    genGeo: async (p5164, p5165) => vThis31.generateSphere(...p5164.size, p5165),
    hasSound: true,
    notTechnical: true,
    notStyleable: true,
    defaultSize: [5, 5, 5],
    hideBoundingBox: false,
    noCollision: true,
    tool: true,
    wireframe: true,
    assetSounds: true
  }, {
    name: "EVENT",
    src: "event_0",
    scale: 2,
    gen: p5166 => vThis31.loadObj(p5166, "models/event_0.obj", "textures/event_0.png", p5166.mSize || this.scale, p5166.color, "mesh"),
    texRange: 3,
    noExport: true,
    localOnly: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    complex: true,
    castShadow: true,
    receiveShadow: true,
    variants: [{
      name: "Random",
      id: 0
    }, {
      name: "Yellow",
      id: 1
    }, {
      name: "Pink",
      id: 2
    }, {
      name: "Blue",
      id: 3
    }, {
      name: "Golden",
      id: 4
    }, {
      name: "Diamond",
      id: 5
    }]
  }, {
    name: "TERMINAL",
    src: "cube_0",
    genGeo: async (p5167, p5168) => vThis31.generateCube(p5167, p5168),
    localOnly: true,
    editFog: true,
    movingTexture: true,
    frameTexture: true,
    defaultSize: [10, 10, 10],
    hasHealth: true,
    scalable: true,
    editAmb: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    editPen: true,
    texturable: true,
    assetTextures: true,
    tool2: true,
    castShadow: true,
    receiveShadow: true,
    hasBorder: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    canTrans: true,
    canStretch: true,
    interactMsg: true,
    stepSrc: true,
    showMinimap: true
  }, {
    name: "PREMIUM_ZONE",
    src: "cube_0",
    genGeo: async (p5169, p5170) => vThis31.generateCube(p5169, p5170),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 16498733,
    tool: true,
    hasBorder: true,
    zone: true,
    forceCollision: true,
    hasHealth: true,
    canInterface: true,
    canDirectionalScale: true
  }, {
    name: "VERIFIED_ZONE",
    src: "cube_0",
    genGeo: async (p5171, p5172) => vThis31.generateCube(p5171, p5172),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 4244735,
    tool: true,
    hasBorder: true,
    zone: true,
    forceCollision: true,
    hasHealth: true,
    canInterface: true,
    canDirectionalScale: true
  }, {
    name: "CUSTOM_ASSET",
    src: "model",
    scale: 1,
    custom: true,
    gen: p5173 => vThis31[(p5173.assetID || "").includes("g") || (p5173.assetID || "").includes("q") || (p5173.assetID || "").includes("f") ? "loadAnimObj" : "loadObj"](p5173, "model.obj", "model.png", p5173.mSize || this.scale, p5173.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    complex: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    hasSpin: true,
    hasSpinDir: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    canInterface: true,
    canScript: true,
    editRenderSide: true,
    editAlphaTest: true,
    alterHitbox: true,
    editFog: true,
    canTrans: true,
    canComplexColl: true,
    showMinimap: true
  }, {
    name: "BOMB_SITE",
    src: "cube_0",
    genGeo: async (p5174, p5175) => vThis31.generateObjective(p5174, p5175, true),
    notTechnical: true,
    notStyleable: true,
    defaultSize: [25, 25, 25],
    scalable: true,
    doubleSide: true,
    lineCol: 9600493,
    tool: true,
    zone: true,
    doubleSide: true,
    canDirectionalScale: true
  }, {
    name: "BOOST_PAD",
    src: "cube_0",
    scale: 4,
    genGeo: async (p5176, p5177) => vThis31.generatePad(p5176, p5177),
    notTechnical: true,
    notStyleable: true,
    defaultSize: [10, 0.5, 10],
    scalable: true,
    tool: true,
    scaleWithSize: false,
    lineCol: 13107455,
    noDefault: true,
    bounce: true,
    canDirectionalScale: true,
    customDirection: true,
    altDirection: true
  }, {
    name: "TEAM_ZONE",
    src: "cube_0",
    genGeo: async (p5178, p5179) => vThis31.generateCube(p5178, p5179),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    teamable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 4244735,
    tool: true,
    hasBorder: true,
    zone: true,
    forceCollision: true,
    hasHealth: true,
    canInterface: true,
    canDirectionalScale: true
  }, {
    name: "CYLINDER",
    src: "cube_0",
    genGeo: async (p5180, p5181) => vThis31.generateCylinder(p5180, p5181),
    canInterface: true,
    hasHealth: true,
    movingTexture: true,
    frameTexture: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    texturable: true,
    assetTextures: true,
    castShadow: true,
    receiveShadow: true,
    hasSpin: true,
    fakeScale: true,
    doubleSide: true,
    canTrans: true,
    canStretch: true,
    editBulletCol: true,
    editAICol: true,
    editPen: true,
    canComplexColl: true
  }, {
    name: "POLICE",
    src: "police_0",
    scale: 4,
    mlt: 1,
    gen: p5182 => vThis31.loadObj(p5182, "models/police_0.obj", "textures/police_0.png", p5182.mSize || this.scale, p5182.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true
  }, {
    name: "CAGE",
    src: "cage_0",
    scale: 6,
    isProp: true,
    gen: p5183 => vThis31.loadObj(p5183, "models/cage_0.obj", "textures/cage_0.png", p5183.mSize || this.scale, p5183.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true
  }, {
    name: "EBARREL",
    src: "ebarrel_0",
    scale: 4,
    mlt: 1,
    isProp: true,
    CP: -1,
    gen: p5184 => vThis31.loadObj(p5184, "models/ebarrel_0.obj", "textures/ebarrel_0.png", p5184.mSize || this.scale, p5184.color, "mesh"),
    hasHealth: true,
    editColor: true,
    complex: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Poly",
      id: 1,
      diffM: true
    }, {
      name: "Fuel",
      id: 2,
      diffM: true
    }]
  }, {
    name: "SHOWCASE",
    src: null,
    scale: 1,
    mlt: 1,
    noCol: true,
    noCollision: true,
    gen: p5185 => vThis31.loadItem(p5185),
    editColor: true,
    complex: true,
    editOpac: true,
    dontRound: true,
    hasSpin: true,
    hasSpinDir: true,
    castShadow: true,
    receiveShadow: true
  }, {
    name: "POINT_LIGHT",
    src: "cube_0",
    edCat: "lights",
    noCol: true,
    genGeo: async (p5186, p5187) => vThis31.generatePointLight(...p5186.size, p5187),
    notTechnical: true,
    noTexture: true,
    wireframe: true,
    tool: true,
    defaultSize: [5, 5, 5],
    editColor: true,
    hideBoundingBox: false,
    noCollision: true,
    light: true,
    noDetail: true
  }, {
    name: "GHOST",
    src: "ghost_0",
    scale: 4,
    gen: p5188 => vThis31.loadObj(p5188, "models/ghost_0.obj", "textures/ghost_0.png", p5188.mSize || this.scale, p5188.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    emiss: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true
  }, {
    name: "AI_SPAWNER",
    src: "ghost_0",
    ai: true,
    scale: 4,
    gen: p5189 => vThis31[(p5189.assetID || "").includes("g") || (p5189.assetID || "").includes("q") || (p5189.assetID || "").includes("f") ? "loadAnimObj" : "loadObj"](p5189, "models/ghost_0.obj", "textures/ghost_0.png", p5189.mSize || this.scale, p5189.color, "mesh", p5189.mYOff || 0, 0, UTILS.toRad(p5189.mROff || 0)),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    complex: true,
    teamable: true,
    castShadow: true,
    receiveShadow: true,
    transparent: true,
    customScore: true,
    canInterface: true,
    canTargetInterface: true,
    alterHitbox: true,
    tool2: true,
    editRenderSide: true,
    editAlphaTest: true,
    editFog: true,
    canTrans: true,
    frameTexture: true
  }, {
    name: "PUMPKIN",
    src: "pumpkin_0",
    scale: 4,
    mlt: 1,
    isProp: true,
    gen: p5190 => vThis31.loadObj(p5190, "models/pumpkin_0.obj", "textures/pumpkin_0.png", p5190.mSize || this.scale, p5190.color, "mesh"),
    emiss: true,
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true
  }, {
    name: "RUNE",
    src: "rune_0",
    noCol: true,
    genGeo: async p5191 => vThis31.generateRune(p5191, p5191.size[0], p5191.size[2]),
    defaultSize: [20, 0.01, 20],
    notTechnical: true,
    movingTexture: true,
    scalable: true,
    noCollision: true,
    scaleWithSize: true,
    editOpac: true,
    editColor: true,
    editEmissive: true,
    lineCol: 16711935,
    castShadow: false,
    receiveShadow: true,
    complex: true,
    doubleSide: true,
    fakeScale: true,
    alphaTest: 0.9,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    canSprite: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true
  }, {
    name: "SKELETON",
    src: "skeleton_0",
    scale: 4,
    mlt: 1,
    isProp: true,
    gen: p5192 => vThis31.loadObj(p5192, "models/skeleton_0.obj", "textures/skeleton_0.png", p5192.mSize || this.scale, p5192.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true
  }, {
    name: "KNIGHT",
    src: "knight_0",
    scale: 4,
    CPY: 4,
    mlt: 1,
    isProp: true,
    gen: p5193 => vThis31.loadObj(p5193, "models/knight_0.obj", "textures/knight_0.png", p5193.mSize || this.scale, p5193.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true
  }, {
    name: "GIFT",
    src: "gift_0",
    scale: 2,
    isProp: true,
    CPY: 0,
    CP: 0,
    mlt: 1,
    gen: p5194 => vThis31.loadObj(p5194, "models/gift_0.obj", "textures/gift_0.png", p5194.mSize || this.scale, p5194.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    texRange: 3,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true,
    variants: [{
      name: "Random",
      id: 0
    }, {
      name: "Pink",
      id: 1
    }, {
      name: "Yellow",
      id: 2
    }, {
      name: "Green",
      id: 3
    }, {
      name: "White",
      id: 4
    }]
  }, {
    name: "CHRISTMASTREE",
    src: "christmastree_0",
    scale: 2,
    mlt: 1,
    gen: p5195 => vThis31.loadObj(p5195, "models/christmastree_0.obj", "textures/christmastree_0.png", p5195.mSize || this.scale, p5195.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true
  }, {
    name: "CANE",
    src: "cane_0",
    scale: 2,
    mlt: 1,
    gen: p5196 => vThis31.loadObj(p5196, "models/cane_0.obj", "textures/cane_0.png", p5196.mSize || this.scale, p5196.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    noMinimap: true
  }, {
    name: "LIGHT_BAR",
    src: "cube_0",
    noCol: true,
    edCat: "lights",
    genGeo: async p5197 => vThis31.generateBar(p5197, p5197.size[0], p5197.size[2]),
    notTechnical: true,
    defaultSize: [10, 0.01, 5],
    movingTexture: true,
    dontRound: true,
    scalable: true,
    canTerrain: true,
    noDetail: true,
    noCollision: true,
    scaleWithSize: true,
    editOpac: true,
    editColor: true,
    lineCol: 16711935,
    castShadow: true,
    receiveShadow: true,
    complex: true,
    doubleSide: true,
    blending: 2,
    canSprite: true,
    transparent: true,
    canDirectionalScale: true
  }, {
    name: "PATH_NODE",
    src: "cube_0",
    noCol: true,
    genGeo: async (p5198, p5199) => vThis31.generateOcta(...p5198.size, p5199),
    notTechnical: true,
    notStyleable: true,
    defaultSize: [5, 5, 5],
    lineCol: 16711935,
    noTexture: true,
    hideBoundingBox: false,
    noCollision: true,
    tool: true
  }, {
    name: "DIRECTIONAL_LIGHT",
    src: "cube_0",
    noCol: true,
    edCat: "lights",
    genGeo: async (p5200, p5201) => vThis31.generateDirectionalLight(...p5200.size, p5201),
    notTechnical: true,
    defaultSize: [4, 4, 4],
    editColor: true,
    wireframe: true,
    tool: true,
    noTexture: true,
    noDetail: true,
    noCollision: true,
    lineCol: 16711935,
    castShadow: true,
    receiveShadow: true,
    complex: true,
    doubleSide: true,
    hideBoundingBox: false
  }, {
    name: "RECTAREA_LIGHT",
    src: "cube_0",
    noCol: true,
    edCat: "lights",
    genGeo: async p5202 => vThis31.generateRectAreaLight(p5202, p5202.size[0], p5202.size[1]),
    notTechnical: true,
    defaultSize: [10, 10, 0.01],
    dontRound: true,
    scalable: true,
    scaleWithSize: true,
    editColor: true,
    tool: true,
    noTexture: true,
    noDetail: true,
    noCollision: true,
    lineCol: 16711935,
    castShadow: true,
    receiveShadow: true,
    complex: true,
    doubleSide: true,
    hideBoundingBox: false,
    canDirectionalScale: true
  }, {
    name: "SPOT_LIGHT",
    src: "cube_0",
    noCol: true,
    edCat: "lights",
    genGeo: async (p5203, p5204) => vThis31.generateSpotLight(...p5203.size, p5204),
    notTechnical: true,
    defaultSize: [4, 4, 4],
    editColor: true,
    wireframe: true,
    tool: true,
    noTexture: true,
    noDetail: true,
    noCollision: true,
    lineCol: 16711935,
    castShadow: true,
    receiveShadow: true,
    complex: true,
    doubleSide: true,
    hideBoundingBox: false
  }, {
    name: "PRIZE_WHEEL",
    src: "cube_0",
    genGeo: async p5205 => vThis31.generateSpinner(p5205, p5205.direction),
    defaultSize: [0.01, 10, 10],
    customDirection: true,
    extraDirection: true,
    scalable: true,
    forceCollision: true,
    editAmb: true,
    scaleWithSize: false,
    lineCol: 16711935,
    tool2: true,
    castShadow: true,
    receiveShadow: true,
    canTrans: true,
    canStretch: true,
    noScaleX: true,
    alphaTest: 0.02,
    fakeScale: 2,
    noRotation: true
  }, {
    name: "KR_ZONE",
    src: "cube_0",
    genGeo: async (p5206, p5207) => vThis31.generateCube(p5206, p5207),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 4244735,
    tool: true,
    hasBorder: true,
    zone: true,
    forceCollision: true,
    hasHealth: true,
    canInterface: true,
    noMinimap: true,
    canDirectionalScale: true
  }, {
    name: "NOPVP_ZONE",
    src: "cube_0",
    genGeo: async (p5208, p5209) => vThis31.generateCube(p5208, p5209),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 4244735,
    tool: true,
    hasBorder: true,
    zone: true,
    forceCollision: true,
    hasHealth: true,
    canInterface: true,
    noMinimap: true,
    canDirectionalScale: true
  }, {
    name: "PVP_ZONE",
    src: "cube_0",
    genGeo: async (p5210, p5211) => vThis31.generateCube(p5210, p5211),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 4244735,
    tool: true,
    hasBorder: true,
    zone: true,
    forceCollision: true,
    hasHealth: true,
    canInterface: true,
    noMinimap: true,
    canDirectionalScale: true
  }, {
    name: "LEADERBOARD",
    src: "cube_0",
    noCol: true,
    genGeo: async p5212 => vThis31.generateSign(p5212, 0, 0, 0, ...p5212.size),
    notTechnical: true,
    movingTexture: true,
    hasText: true,
    defaultSize: [40, 0.01, 10],
    forceCollision: true,
    lineCol: 9849600,
    scalable: true,
    scaleWithSize: true,
    hideBoundingBox: false,
    tool: true,
    castShadow: true,
    receiveShadow: true,
    doubleSide: true,
    canSprite: true,
    noMinimap: true,
    canDirectionalScale: true
  }, {
    name: "TILES",
    src: "tiles_0",
    scale: 10,
    gen: p5213 => vThis31.loadObj(p5213, "models/tiles_0.obj", "textures/tiles_0.png", p5213.mSize || this.scale, p5213.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    noMinimap: true
  }, {
    name: "CLOUDS",
    src: "clouds_0",
    scale: 3,
    gen: p5214 => vThis31.loadObj(p5214, "models/clouds_0.obj", "textures/clouds_0.png", p5214.mSize || this.scale, p5214.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    noMinimap: true
  }, {
    name: "PARTNER_ZONE",
    src: "cube_0",
    genGeo: async (p5215, p5216) => vThis31.generateCube(p5215, p5216),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 10039961,
    tool: true,
    hasBorder: true,
    zone: true,
    forceCollision: true,
    hasHealth: true,
    canInterface: true,
    noMinimap: true,
    canDirectionalScale: true
  }, {
    name: "SPRITE",
    src: "cube_0",
    genGeo: async p5217 => vThis31.generatePlane(p5217, p5217.size[0], p5217.size[2]),
    defaultSize: [4, 0.01, 4],
    noCol: true,
    movingTexture: true,
    frameTexture: true,
    dontRound: true,
    scalable: true,
    canTerrain: true,
    scaleWithSize: true,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    texturable: true,
    assetTextures: true,
    castShadow: true,
    receiveShadow: true,
    doubleSide: true,
    canTrans: true,
    canDirectionalScale: true
  }, {
    name: "DOMINATION_ZONE",
    src: "cube_0",
    genGeo: async (p5218, p5219) => vThis31.generateObjective(p5218, p5219),
    notTechnical: true,
    notStyleable: true,
    defaultSize: [35, 35, 35],
    scalable: true,
    doubleSide: true,
    lineCol: 14606046,
    tool: true,
    zone: true,
    canDirectionalScale: true
  }, {
    name: "ROPE_LADDER",
    src: "cube_0",
    genGeo: async (p5220, p5221) => vThis31.generateRope(p5220, p5221),
    editFog: true,
    movingTexture: true,
    frameTexture: true,
    notTechnical: true,
    defaultSize: [2, 10, 2],
    editAmb: true,
    scalable: true,
    scaleWithSize: false,
    editColor: true,
    editEmissive: true,
    editOpac: true,
    hideBoundingBox: false,
    fakeScale: true,
    texturable: true,
    assetTextures: true,
    castShadow: true,
    receiveShadow: true,
    canStretch: true,
    canTrans: true,
    stepSrc: true
  }, {
    name: "ENVIRONMENT_ZONE",
    src: "cube_0",
    genGeo: async (p5222, p5223) => vThis31.generateCube(p5222, p5223),
    notStyleable: true,
    defaultSize: [100, 100, 100],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 4244735,
    tool: true,
    zone: true,
    noMinimap: true,
    canDirectionalScale: true
  }, {
    name: "KPD_ZONE",
    src: "cube_0",
    genGeo: async (p5224, p5225) => vThis31.generateCube(p5224, p5225),
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    noTexture: true,
    opacity: 0.3,
    lineCol: 4244735,
    tool: true,
    hasBorder: true,
    zone: true,
    forceCollision: true,
    hasHealth: true,
    canInterface: true,
    noMinimap: true,
    canDirectionalScale: true
  }, {
    name: "DUMPSTER",
    src: "dumpster_0",
    scale: 4,
    gen: p5226 => vThis31.loadObj(p5226, "models/dumpster_0.obj", "textures/dumpster_0.png", p5226.mSize || this.scale, p5226.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true
  }, {
    name: "SERVER_NODE",
    src: "cube_0",
    genGeo: async (p5227, p5228) => vThis31.generateServerNode(p5227, p5228),
    notStyleable: true,
    defaultSize: [5, 5, 5],
    scalable: false,
    scaleWithSize: false,
    doubleSide: true,
    tool: true,
    transparent: true,
    lineCol: 0,
    forceCollision: true,
    hasHealth: true,
    canInterface: true,
    noMinimap: true
  }, {
    name: "LAMP",
    src: "lamp_0",
    scale: 1,
    gen: p5229 => vThis31.loadObj(p5229, "models/lamp_0.obj", "textures/lamp_0.png", p5229.mSize || this.scale, p5229.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    noMinimap: true,
    variants: [{
      name: "Wall Lantern",
      id: 0
    }, {
      name: "Street Light",
      id: 1,
      diffM: true
    }, {
      name: "Barn Light",
      id: 2,
      diffM: true
    }]
  }, {
    name: "WATER_TOWER",
    src: "water_tower_0",
    scale: 10,
    gen: p5230 => vThis31.loadObj(p5230, "models/water_tower_0.obj", "textures/water_tower_0.png", p5230.mSize || this.scale, p5230.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    showMinimap: true,
    variants: [{
      name: "Default",
      id: 0
    }, {
      name: "Tank only",
      id: 1,
      diffM: true
    }]
  }, {
    name: "AC_UNIT",
    src: "ac_unit_0",
    scale: 5,
    gen: p5231 => vThis31.loadObj(p5231, "models/ac_unit_0.obj", "textures/ac_unit_0.png", p5231.mSize || this.scale, p5231.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    noMinimap: true
  }, {
    name: "SHEET_METAL",
    src: "sheet_metal_0",
    scale: 0.5,
    gen: p5232 => vThis31.loadObj(p5232, "models/sheet_metal_0.obj", "textures/sheet_metal_0.png", p5232.mSize || this.scale, p5232.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    noMinimap: true
  }, {
    name: "ANTENNA",
    src: "antenna_0",
    scale: 10,
    gen: p5233 => vThis31.loadObj(p5233, "models/antenna_0.obj", "textures/antenna_0.png", p5233.mSize || this.scale, p5233.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    noMinimap: true,
    variants: [{
      name: "Stage 1",
      id: 0
    }, {
      name: "Stage 2",
      id: 1,
      diffM: true
    }, {
      name: "Stage 3",
      id: 2,
      diffM: true
    }, {
      name: "Stage 4",
      id: 3,
      diffM: true
    }]
  }, {
    name: "SATELLITE_DISH",
    src: "satellite_dish_0",
    scale: 5,
    gen: p5234 => vThis31.loadObj(p5234, "models/satellite_dish_0.obj", "textures/satellite_dish_0.png", p5234.mSize || this.scale, p5234.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true,
    noMinimap: true
  }, {
    name: "SPRAY",
    src: "cube_0",
    genGeo: async p5235 => vThis31.generatePlane(p5235, p5235.size[0], p5235.size[2]),
    defaultSize: [20, 0.01, 20],
    dontRound: true,
    scalable: true,
    editAmb: true,
    scaleWithSize: true,
    texturable: true,
    castShadow: true,
    receiveShadow: true,
    canTrans: true,
    canStretch: true,
    alphaTest: 0.02,
    noCol: true,
    noCollision: true,
    editColor: true,
    editOpac: true,
    noCol: true,
    forceCollision: true,
    sprayTexture: true,
    fakeScale: true,
    tool: true
  }, {
    name: "WEAPONBOX",
    src: "weaponbox_0",
    scale: 5,
    gen: p5236 => vThis31.loadObj(p5236, "models/weaponbox_0.obj", "textures/weaponbox_0.png", p5236.mSize || this.scale, p5236.color, "mesh"),
    hasHealth: true,
    editColor: true,
    editOpac: true,
    dontRound: true,
    castShadow: true,
    receiveShadow: true,
    canInterface: true,
    canWallJump: true,
    canGrapple: true,
    canImpulse: true,
    editBulletCol: true,
    editAICol: true,
    stepSrc: true
  }, {
    name: "MYSTERY_BOX",
    src: "weaponbox_0",
    scale: 5,
    genGeo: async (p5237, p5238) => vThis31.generateMysteryBox(p5237, p5238),
    defaultSize: [10, 7.27, 17.91],
    customScore: true,
    scalable: false,
    notStyleable: true,
    noTexture: true,
    tool: true,
    scaleWithSize: false,
    dontRound: true,
    mysteryBox: true,
    noMinimap: true
  }, {
    name: "PERK_MACHINE",
    src: "perkmachine_0",
    scale: 5,
    genGeo: async (p5239, p5240) => vThis31.generatePerkMachine(p5239, p5240),
    defaultSize: [6.7, 21.9, 8.41],
    customScore: true,
    scalable: false,
    notStyleable: true,
    noTexture: true,
    tool: true,
    scaleWithSize: false,
    dontRound: true,
    perkMachine: true,
    hasHealth: true,
    canInterface: true,
    canStretch: true,
    hasBorder: true
  }, {
    name: "AI_REDIRECTION",
    src: "cube_0",
    genGeo: async (p5241, p5242) => vThis31.generateCube(p5241, p5242),
    notTechnical: true,
    notStyleable: true,
    defaultSize: [10, 10, 10],
    scalable: true,
    scaleWithSize: false,
    hideBoundingBox: false,
    customDirection: true,
    castShadow: true,
    receiveShadow: true,
    noRotation: true,
    noTexture: true,
    tool: true,
    opacity: 0.3,
    lineCol: 3080191,
    noCol: true,
    forceCollision: true,
    noMinimap: true,
    canDirectionalScale: true
  }, {
    name: "KRUM_MACHINE",
    src: "krummachine_0",
    scale: 7,
    genGeo: async (p5243, p5244) => vThis31.generateKrumMachine(p5243, p5244),
    defaultSize: [17.14, 22.3, 15.73],
    customScore: true,
    scalable: false,
    notStyleable: true,
    noTexture: true,
    tool: true,
    scaleWithSize: false,
    dontRound: true,
    packapunch: true,
    hasBorder: true
  }, {
    name: "BOT_SPAWNER",
    src: "cube_0",
    genGeo: async (p5245, p5246) => vThis31.generateServerNode(p5245, p5246),
    localOnly: true,
    notStyleable: true,
    defaultSize: [5, 5, 5],
    scalable: false,
    scaleWithSize: false,
    doubleSide: true,
    tool: true,
    transparent: true,
    customDirection: true,
    lineCol: 0,
    noCol: true,
    noMinimap: true,
    bot: true
  }, {
    name: "MAP_ANCHOR",
    src: "check_0",
    genGeo: async (p5247, p5248) => vThis31.generateCubeTool(p5247, p5248, [1, 500, 1]),
    notStyleable: true,
    defaultSize: [1, 500, 1],
    scalable: false,
    scaleWithSize: false,
    doubleSide: true,
    tool: true,
    transparent: true,
    lineCol: 16711680,
    forceCollision: true,
    noMinimap: true
  }];
  this.props = [];
  for (var vLN0718 = 0; vLN0718 < this.prefabs.length; vLN0718++) {
    this.prefabs[vLN0718].id = vLN0718;
    if (this.prefabs[vLN0718].isProp && UTILS) {
      this.props.push({
        id: vLN0718,
        name: UTILS.formatConstName(this.prefabs[vLN0718].name),
        thumbnail: UTILS.assetsUrl("/img/props/prop_" + vLN0718 + ".png")
      });
    }
  }
  this.getPrefabIdByName = function (p5249) {
    p5249 = p5249.toUpperCase();
    for (var vLN0719 = 0; vLN0719 < this.prefabs.length; vLN0719++) {
      if (this.prefabs[vLN0719].name == p5249) {
        return vLN0719;
      }
    }
    return 0;
  };
  this.getPrefabByName = function (p5250) {
    p5250 = p5250.toUpperCase();
    for (var vLN0720 = 0; vLN0720 < this.prefabs.length; vLN0720++) {
      if (this.prefabs[vLN0720].name == p5250) {
        return this.prefabs[vLN0720];
      }
    }
    return null;
  };
  this.prefabExist = function (p5251) {
    p5251 = p5251.toUpperCase();
    for (var vLN0721 = 0; vLN0721 < this.prefabs.length; vLN0721++) {
      if (this.prefabs[vLN0721].name == p5251) {
        return true;
      }
    }
    return false;
  };
  if (p5102) {
    let v4522 = new p5102.Vector3();
    let v4523 = new p5102.TextureLoader();
    let v4524 = new p5102.LoadingManager();
    let v4525 = new p5102.OBJLoader(v4524);
    let v4526 = new p5102.GLTFLoader(v4524);
    v4526.setMeshoptDecoder(p5102.MeshoptDecoder);
    let v4527 = new p5102.FBXLoader(v4524);
    window.loadedGeos = [];
    this.createMesh = function (p5252, p5253, p5254, p5255, p5256, p5257, p5258, p5259, p5260, p5261) {
      var v4528;
      var v4529 = p5252.prefab.frames || 0;
      var v4530 = Math.min(10, v4529);
      var v4531 = v4529 > 10 ? Math.ceil(v4529 / 10) : 0;
      if (p5254) {
        v4528 = v4523.load(UTILS[p5261 ? "userAssetsUrl" : "assetsUrl"](p5254), p5262 => {
          p5262.wrapS = p5102.RepeatWrapping;
          p5262.wrapT = p5102.RepeatWrapping;
          p5262.repeat.set(1, 1);
          p5262.repeat.set(v4529 ? 1 / v4530 : p5252.prefab.repeatX || 1, v4531 ? 1 / v4531 : p5252.prefab.repeatY || 1);
          p5262.minFilter = p5102.NearestFilter;
          p5262.magFilter = p5102.NearestFilter;
          p5262.needsUpdate = true;
        });
      }
      var v4532 = new p5102.StrippedLambertMaterial({
        map: v4528,
        vertexColors: true,
        color: p5256 || "#ffffff",
        shininess: 60,
        specular: 2697513,
        alphaTest: p5252.alphaTest ? p5252.alphaTest : p5261 && p5252.assetID.includes("a") ? 0.02 : p5252.prefab.alphaTest || 0
      });
      if (p5261 || p5252.prefab.gen) {
        p5253.computeBoundingBox();
        var v4533 = p5253.boundingBox.getCenter(v4522);
        p5257 += -v4533.y * p5255;
      }
      p5253.computeVertexNormals();
      var v4534 = new p5102.Mesh(p5253, v4532);
      v4534.scale.setScalar(p5255 || 1);
      v4534.position.y += p5257;
      v4534.rotateX(p5258 || 0);
      v4534.rotateY(p5259 || 0);
      if (p5260) {
        if (p5252[p5260]) {
          p5252.remove(p5252[p5260]);
          p5252[p5260] = null;
        }
        p5252[p5260] = v4534;
        p5252.add(p5252[p5260]);
      } else {
        p5252.add(v4534);
      }
      return v4534;
    };
    this.loadObj = function (p5263, p5264, p5265, p5266, p5267, p5268 = null, p5269 = 0, p5270 = 0, p5271 = 0) {
      return new Promise(p5272 => {
        var v4535 = p5263.assetID && p5263.assetID.length;
        var v4536 = null;
        var vLSObj = "obj";
        if (v4535) {
          var v4537 = p5263.assetID.replace(/[^\d]/g, "");
          if (p5263.assetID.includes("g")) {
            vLSObj = "gltf";
          }
          if (p5263.assetID.includes("q")) {
            vLSObj = "glb";
          }
          if (p5263.assetID.includes("f")) {
            vLSObj = "fbx";
          }
          p5264 = v4537 + "/model." + vLSObj;
          p5265 = v4537 + "/model.png";
          v4536 = function (p5273) {
            KE.updateProgress((p5273.loaded / p5273.total * 100).round(0));
          };
        }
        if (p5263.prefab.variants && p5263.texVar && p5263.prefab.variants[p5263.texVar]) {
          if (p5263.prefab.variants[p5263.texVar].diffM) {
            p5264 = p5264.replace("_0", "_0_" + p5263.prefab.variants[p5263.texVar].id);
          }
          p5265 = p5265.replace("_0", "_0_" + p5263.prefab.variants[p5263.texVar].id);
        } else if (p5263.prefab.texRange) {
          var v4538 = UTILS.randInt(0, p5263.prefab.texRange);
          if (v4538 > 0) {
            p5265 = p5265.replace("_0", "_0_" + v4538);
          }
        }
        var v4539 = window.loadedGeos[p5264 + vLSObj];
        if (v4539) {
          p5272(vThis31.createMesh(p5263, v4539, p5265, p5266, p5267, p5269, p5270, p5271, p5268, v4535));
        } else {
          v4539 = new p5102.BufferGeometry();
          (vLSObj == "gltf" || vLSObj == "glb" ? v4526 : vLSObj == "fbx" ? v4527 : v4525).load(UTILS[v4535 ? "userAssetsUrl" : "assetsUrl"](p5264), p5274 => {
            if (p5274.scene) {
              p5274 = p5274.scene;
            }
            var v4540 = p5274.children[0].geometry;
            if (p5274.children.length > 1) {
              var vA242 = [];
              for (var vLN0724 = 0; vLN0724 < p5274.children.length; ++vLN0724) {
                if (p5274.children[vLN0724]) {
                  if (p5274.children[vLN0724].type != "Object3D") {
                    vA242.push(vThis31.updateGeoFromMesh(p5274.children[vLN0724]));
                  } else {
                    var vA241 = [];
                    for (var vLN0723 = 0; vLN0723 < p5274.children[vLN0724].children.length; ++vLN0723) {
                      if (p5274.children[vLN0724].children[vLN0723] && p5274.children[vLN0724].children[vLN0723].geometry && p5274.children[vLN0724].children[vLN0723].type != "Object3D") {
                        vA241.push(vThis31.updateGeoFromMesh(p5274.children[vLN0724].children[vLN0723]));
                      }
                    }
                    vA242.push(GEOS.mergeGeometries(vA241));
                  }
                }
              }
              v4540 = GEOS.mergeGeometries(vA242);
            } else if (p5274.children[0].type == "Object3D" && !p5274.children[0].geometry && p5274.children[0].children) {
              var vA242 = [];
              for (var vLN0724 = 0; vLN0724 < p5274.children[0].children.length; ++vLN0724) {
                if (p5274.children[0].children[vLN0724] && p5274.children[0].children[vLN0724].geometry) {
                  vA242.push(vThis31.updateGeoFromMesh(p5274.children[0].children[vLN0724]));
                }
              }
              v4540 = GEOS.mergeGeometries(vA242);
            }
            v4539.copy(v4540);
            window.loadedGeos[p5264 + vLSObj] = v4539;
            p5272(vThis31.createMesh(p5263, v4539, p5265, p5266, p5267, p5269, p5270, p5271, p5268, v4535));
          }, v4536);
        }
      });
    };
    this.createAnimMesh = function (p5275, p5276, p5277, p5278, p5279, p5280, p5281, p5282, p5283, p5284) {
      var v4541 = p5284 == "fbx" ? p5276 : p5276.scene || p5276.scenes[0];
      p5275.clips = p5276.animations || [];
      v4541.scale.setScalar(p5277 || 1);
      const v4542 = new p5102.Box3().setFromObject(v4541);
      const v4543 = v4542.getSize(new p5102.Vector3());
      v4541.position.y += v4541.position.y - v4543.y / 2 + p5279;
      v4541.rotateX(p5280 || 0);
      v4541.rotateY(p5281 || 0);
      if (p5275.clips.length) {
        p5275.mixer = new p5102.AnimationMixer(v4541);
        p5275.playClip = function (p5285, p5286 = 0) {
          const v4544 = this.clips.find(p5287 => p5287.name === p5285);
          if (v4544) {
            const v4545 = this.mixer.clipAction(v4544);
            v4545.reset();
            if (p5286) {
              v4545.setLoop(p5102.LoopRepeat, p5286);
            }
            v4545.play();
          }
        };
        p5275.playAllClips = function (p5288 = 0) {
          this.clips.forEach(p5289 => {
            var v4546 = this.mixer.clipAction(p5289);
            v4546.reset();
            if (p5288) {
              v4546.setLoop(p5102.LoopRepeat, p5288);
            }
            v4546.play();
          });
        };
        p5275.stopAllClips = function () {
          this.clips.forEach(p5290 => {
            this.mixer.clipAction(p5290).stop();
          });
        };
        p5275.playClip("Idle");
      }
      if (p5282) {
        if (p5275[p5282]) {
          p5275.remove(p5275[p5282]);
          p5275[p5282] = null;
        }
        p5275[p5282] = v4541;
        p5275.add(p5275[p5282]);
      } else {
        p5275.add(v4541);
      }
      return v4541;
    };
    this.loadAnimObj = function (p5291, p5292, p5293, p5294, p5295, p5296 = null, p5297 = 0, p5298 = 0, p5299 = 0) {
      return new Promise(p5300 => {
        var v4547 = p5291.assetID && p5291.assetID.length;
        var v4548 = null;
        var vLSGltf = "gltf";
        if (v4547) {
          var v4549 = p5291.assetID.replace(/[^\d]/g, "");
          if (p5291.assetID.includes("g")) {
            vLSGltf = "gltf";
          }
          if (p5291.assetID.includes("q")) {
            vLSGltf = "glb";
          }
          if (p5291.assetID.includes("f")) {
            vLSGltf = "fbx";
          }
          p5292 = v4549 + "/model." + vLSGltf;
          p5293 = v4549 + "/model.png";
          v4548 = function (p5301) {
            KE.updateProgress((p5301.loaded / p5301.total * 100).round(0));
          };
        }
        (vLSGltf == "fbx" ? v4527 : v4526).load(UTILS[v4547 ? "userAssetsUrl" : "assetsUrl"](p5292), p5302 => {
          p5300(vThis31.createAnimMesh(p5291, p5302, p5294, p5295, p5297, p5298, p5299, p5296, v4547, vLSGltf));
        }, v4548);
      });
    };
    this.updateGeoFromMesh = function (p5303) {
      p5303.updateMatrix();
      var v4550 = new p5102.BufferGeometry().copy(p5303.geometry);
      var v4551 = p5303.matrixWorld;
      v4551.makeRotationFromQuaternion(p5303.quaternion);
      v4550.scale(...p5303.scale.toArray());
      v4550.applyMatrix4(v4551);
      v4550.translate(...p5303.position.toArray());
      return v4550;
    };
    this.loadItem = function (p5304) {
      var v4552 = store.skins[p5304.itemID || 0];
      var v4553 = weapons[v4552.weapon - 1] || {};
      var vO124 = {
        src: store.types[v4552.assetType || v4552.type || 0] + (v4552.assetType || v4552.type ? v4552.id : v4552.weapon) + (v4552.mid == null ? "" : "_" + v4552.mid),
        texSrc: v4552.mid == null ? v4552.type && v4552.type == itemTypes.MELEE ? v4552.pat ? v4552.tex : "melee/melee_" + (v4552.id || 0) + (v4552.tex ? "_" + v4552.tex : "") : v4552.type ? v4552.tex ? store.types[v4552.assetType || v4552.type || 0] + v4552.id + "_" + v4552.tex : null : v4552.tex ? v4552.tex : "weapons/skins/weapon_" + v4552.weapon + "_" + v4552.id : UTILS.getReModel(store, v4552)
      };
      return this[v4552.hasAnim ? "loadAnimObj" : "loadObj"](p5304, "models/" + vO124.src + ".obj", "textures/" + (vO124.texSrc || vO124.src) + ".png", (p5304.mSize || 1) * (v4552.mScl || v4553.scale || 1), p5304.color, "mesh");
    };
    this.generateSprite = function (p5305, p5306, p5307) {
      let v4554 = new p5102.TextureLoader().load(p5306);
      v4554.magFilter = p5102.NearestFilter;
      let v4555 = new p5102.SpriteMaterial({
        map: v4554,
        color: "#ffffff"
      });
      let v4556 = new p5102.Sprite(v4555);
      if (p5307) {
        v4556.scale.set(p5307, p5307, 1);
      }
      p5305.add(v4556);
    };
    this.generatePlane = function (p5308, p5309, p5310) {
      var v4557 = GEOS.generatePlane(p5310, p5309, {
        scale: p5308.texStretch || p5308.prefab.name == "SPRAY" ? 0 : 1,
        scaleM: p5308.texScale || 0
      }, 0, 0, 0, true);
      v4557 = v4557.clone();
      v4557.scale(p5309, p5310, 1);
      v4557.rotateX(-Math.PI / 2);
      return v4557;
    };
    this.generateSpinner = function (p5311, p5312) {
      var [v4558, v4559, v4560] = p5311.size;
      p5312 = p5312 * Math.PI / 4;
      var v4561 = GEOS.generatePlane(v4559, v4560, {
        scale: 0
      }, 0, 0, 0, true);
      v4561 = v4561.clone();
      v4561.scale(v4560, v4559, 1);
      v4561.rotateY(Math.PI / 2 - p5312);
      return v4561;
    };
    this.generateRectAreaLight = function (p5313, p5314, p5315) {
      var v4562 = GEOS.generatePlane(p5315, p5314, {
        scale: p5313.texStretch ? 0 : 1,
        scaleM: p5313.texScale || 0
      }, 0, 0, 0, true);
      v4562 = v4562.clone();
      v4562.scale(p5314, p5315, 1);
      return v4562;
    };
    this.generateBar = function (p5316, p5317, p5318) {
      var v4563 = GEOS.generatePlane(p5318, p5317, {
        scale: 0
      }, 0, 0, 0, true);
      v4563 = v4563.clone();
      v4563.scale(p5317, p5318, 1);
      v4563.rotateX(-Math.PI / 2);
      return v4563;
    };
    this.generateRune = function (p5319, p5320, p5321) {
      var v4564 = GEOS.generatePlane(p5321, p5320, {
        scale: 0
      }, 0, 0, 0, true);
      v4564 = v4564.clone();
      v4564.scale(p5320, p5321, 1);
      v4564.rotateX(-Math.PI / 2);
      return v4564;
    };
    this.generateLiquid = function (p5322, p5323, p5324) {
      var v4565 = GEOS.generatePlane(p5324, p5323, {
        scale: 1,
        tilesX: p5322.tilesX || 10,
        tilesZ: p5322.tilesZ || 10
      }, 0, 0, 0, true);
      v4565 = v4565.clone();
      v4565.scale(p5323, p5324, 1);
      v4565.rotateX(-Math.PI / 2);
      return v4565;
    };
    this.generateCube = function (p5325, p5326, p5327) {
      var [v4566, v4567, v4568] = p5325.size;
      p5327 = p5327 || {};
      var v4569 = GEOS.generateCube(p5325.faces || [1, 1, 1, 1, 1, 1], v4566, v4567, v4568, {
        scale: p5325.texStretch ? 0 : 1,
        scaleM: p5325.texScale || 0,
        ...p5327
      });
      v4569 = v4569.clone();
      v4569.scale(v4566, v4567, v4568);
      v4569.translate(0, -v4567 / 2, 0);
      return v4569;
    };
    this.generateRope = function (p5328) {
      var [v4570, v4571, v4572] = p5328.size;
      var v4573 = Math.min(v4570, v4572);
      var v4574 = GEOS.generateCube(p5328.faces || [1, 1, 1, 1, 1, 1], v4573, v4571, v4573, {
        scale: p5328.texStretch ? 0 : 1,
        scaleM: p5328.texScale || 0
      }, true);
      v4574 = v4574.clone();
      v4574.scale(v4573, v4571, v4573);
      v4574.translate(0, -v4571 / 2, 0);
      return v4574;
    };
    this.generateSphere = function (p5329, p5330, p5331, p5332) {
      var v4575 = GEOS.generateSphere(p5329, p5330, p5331, {
        scale: 1,
        amb: p5332,
        useScale: true
      }, true);
      v4575 = v4575.clone();
      return v4575;
    };
    this.generateOcta = function () {
      var v4576 = new p5102.OctahedronGeometry(2, 0);
      GEOS.colorize(v4576, null, GEOS.getColor("#ff00ff"));
      return v4576;
    };
    this.generatePointLight = function (p5333, p5334, p5335, p5336) {
      var v4577 = GEOS.generateSphere(p5333, p5334, p5335, {
        scale: 1,
        amb: p5336,
        useScale: true
      }, true);
      v4577 = v4577.clone();
      return v4577;
    };
    this.generateDirectionalLight = function (p5337, p5338, p5339, p5340) {
      var v4578 = GEOS.generateSphere(p5337, p5338, p5339, {
        scale: 1,
        amb: p5340,
        useScale: true
      }, true);
      v4578 = v4578.clone();
      return v4578;
    };
    this.generateSpotLight = function (p5341, p5342, p5343, p5344) {
      var v4579 = GEOS.generateSphere(p5341, p5342, p5343, {
        scale: 1,
        amb: p5344,
        useScale: true
      }, true);
      v4579 = v4579.clone();
      return v4579;
    };
    this.generateCone = function (p5345) {
      var [v4580, v4581, v4582] = p5345.size;
      var v4583 = GEOS.generateCone(v4581, {
        scale: 1,
        useScale: true,
        sides: p5345.sides,
        thetaL: p5345.thetaLength
      }, true);
      v4583 = v4583.clone();
      var v4584 = new p5102.Mesh(v4583);
      v4584.scale.set(v4580 / 2, v4581, v4582 / 2);
      var v4585 = vThis31.updateGeoFromMesh(v4584);
      return v4585;
    };
    this.generateCylinder = function (p5346) {
      var [v4586, v4587, v4588] = p5346.size;
      var v4589 = Math.min(v4586, v4588) / 2;
      var v4590 = GEOS.generateCylinder(v4589 * 2, v4587, v4589 * 2, {
        scale: p5346.texStretch ? 0 : undefined,
        scaleM: p5346.texScale || 0,
        useScale: true,
        open: !!p5346.openEnded,
        sides: p5346.sides,
        rTop: p5346.radiusTop,
        rBot: p5346.radiusBottom,
        thetaS: p5346.thetaStart,
        thetaL: p5346.thetaLength
      }, true);
      v4590 = v4590.clone();
      var v4591 = new p5102.Mesh(v4590);
      v4591.scale.set(v4589, v4587, v4589);
      var v4592 = vThis31.updateGeoFromMesh(v4591);
      return v4592;
    };
    this.generateRamp = function (p5347, p5348) {
      var [v4593, v4594, v4595] = p5347.size;
      var vLN0725 = 0;
      var vA243 = [];
      p5348 = p5348 * Math.PI / 2;
      vLN0725 = 0 - v4594 / 2;
      var v4596 = p5348 != 0 && p5348 != Math.PI;
      if (p5347.enclose) {
        var v4597 = GEOS.generateRamps(v4593, v4594, v4595, {
          scale: p5347.texStretch ? 0 : 1,
          scaleM: p5347.texScale || 0
        }, true);
        v4597 = v4597.clone();
        var v4598 = new p5102.Mesh(v4597);
        v4598.scale.set(v4596 ? v4595 : v4593, v4594, v4596 ? v4593 : v4595);
        v4598.rotateY(Math.PI - p5348);
        vA243.push(vThis31.updateGeoFromMesh(v4598));
      } else {
        ((p5349, p5350, p5351, p5352, p5353, p5354, p5355, p5356, p5357) => {
          p5356 = p5356 || {};
          var v4599 = GEOS.generatePlane(p5354 * 2, p5352, p5356, 0, 0, 0, true);
          v4599 = v4599.clone();
          var v4600 = new p5102.Mesh(v4599);
          v4600.position.set(p5349, p5350 + p5353 / 2, p5351);
          p5354 *= 2;
          var v4601 = Math.sqrt(p5353 * p5353 + p5354 * p5354);
          v4600.scale.set(p5352, v4601, 2);
          v4600.rotateY(-(Math.PI / 2) - p5355);
          v4600.rotateX(Math.asin(p5353 / v4601) - Math.PI / 2);
          v4600.rotateZ(p5357 || 0);
          vA243.push(vThis31.updateGeoFromMesh(v4600));
        })(0, vLN0725, 0, v4596 ? v4593 : v4595, v4594, (v4596 ? v4595 : v4593) / 2, p5348, {
          scale: p5347.texStretch ? 0 : 1,
          scaleM: p5347.texScale || 0
        });
      }
      vA243 = GEOS.mergeGeometries(vA243);
      return vA243;
    };
    let vF17 = (p5358, p5359, p5360, p5361, p5362, p5363, p5364, p5365, p5366, p5367) => {
      p5364 = p5364 || {};
      p5364.premultipliedAlpha = true;
      var v4602 = GEOS.generatePlane(p5363, p5362, p5364, p5359, p5360, p5361, true);
      v4602 = v4602.clone();
      var v4603 = new p5102.Mesh(v4602);
      v4603.position.set(p5359, p5360, p5361);
      v4603.rotateY(p5365 || 0);
      v4603.rotateX((p5366 || 0) - Math.PI / 2);
      v4603.rotateZ(p5367 || 0);
      v4603.scale.set(p5362 * 2, p5363 * 2, 1);
      p5358.push(vThis31.updateGeoFromMesh(v4603));
    };
    let vF18 = (p5368, p5369, p5370, p5371, p5372, p5373, p5374, p5375, p5376) => {
      p5376 = p5376 || {};
      var v4604 = GEOS.generateCube(p5375, p5372, p5373, p5374, p5376, true);
      v4604 = v4604.clone();
      var v4605 = new p5102.Mesh(v4604);
      v4605.position.set(p5369, p5370, p5371);
      v4605.rotation.set(p5376.yR || 0, p5376.xR || 0, p5376.zR || 0);
      v4605.scale.set(p5372, p5373, p5374);
      if (Array.isArray(p5368)) {
        p5368.push(vThis31.updateGeoFromMesh(v4605));
      } else {
        p5368.add(v4605);
      }
      return v4605;
    };
    let vF19 = (p5377, p5378, p5379, p5380, p5381, p5382, p5383, p5384) => {
      p5384 = p5384 || {};
      var v4606 = GEOS.generateSphere(p5381, p5382, p5383, p5384, true);
      v4606 = v4606.clone();
      var v4607 = new p5102.Mesh(v4606);
      v4607.position.set(p5378, p5379 + p5382 / 2, p5380);
      v4607.rotation.set(p5384.yR || 0, p5384.xR || 0, p5384.zR || 0);
      v4607.scale.set(p5381 / 2, p5382 / 2, p5383 / 2);
      if (Array.isArray(p5377)) {
        p5377.push(vThis31.updateGeoFromMesh(v4607));
      } else {
        p5377.add(v4607);
      }
      return v4607;
    };
    let vF20 = (p5385, p5386, p5387, p5388, p5389, p5390, p5391, p5392) => {
      p5392 = p5392 || {};
      var v4608 = GEOS.generateCylinder(v4609, p5390, v4609, p5392, true);
      v4608 = v4608.clone();
      var v4609 = Math.min(p5389, p5391) / 2;
      var v4610 = new p5102.Mesh(v4608);
      v4610.scale.set(v4609, p5390, v4609);
      v4610.position.set(p5386, p5387, p5388);
      v4610.rotation.set(p5392.yR || 0, p5392.xR || 0, p5392.zR || 0);
      if (Array.isArray(p5385)) {
        p5385.push(vThis31.updateGeoFromMesh(v4610));
      } else {
        p5385.add(v4610);
      }
      return v4610;
    };
    this.generateLadder = function (p5393, p5394) {
      var [v4611, v4612, v4613] = p5393.size;
      var vA244 = [];
      p5394 = p5394 * Math.PI / 2;
      let vO125 = {
        x: 0 + config.ladderScale * Math.cos(p5394),
        z: 0 + config.ladderScale * Math.sin(p5394),
        y: 0 - v4612 / 2
      };
      vF18(vA244, vO125.x + config.ladderWidth * Math.sin(p5394), vO125.y, vO125.z + config.ladderWidth * Math.cos(p5394), config.ladderScale * 2, v4612 + 2, config.ladderScale * 2, [1, 1, 1, 1, 1, 1], {
        scale: p5393.texStretch ? 1 : 0.02,
        scaleM: p5393.texScale || 0
      });
      vF18(vA244, vO125.x - config.ladderWidth * Math.sin(p5394), vO125.y, vO125.z - config.ladderWidth * Math.cos(p5394), config.ladderScale * 2, v4612 + 2, config.ladderScale * 2, [1, 1, 1, 1, 1, 1], {
        scale: p5393.texStretch ? 1 : 0.02,
        scaleM: p5393.texScale || 0
      });
      var vLN65 = 6;
      for (var v4614 = Math.floor(v4612 / vLN65), vLN0726 = 0; vLN0726 < v4614; ++vLN0726) {
        vF17(vA244, vO125.x, vO125.y + vLN65 * (vLN0726 + 1) + UTILS.randFloat(-1, 1), vO125.z, config.ladderWidth, config.ladderScale, {
          scale: p5393.texStretch ? 1 : 0.02,
          scaleM: p5393.texScale || 0
        }, -p5394 + Math.PI / 2, Math.PI / 2, UTILS.randFloat(-0.1, 0.1));
      }
      vA244 = GEOS.mergeGeometries(vA244);
      return vA244;
    };
    this.generateBillboard = function (p5395, p5396, p5397, p5398, p5399, p5400) {
      var v4615 = GEOS.generatePlane(p5400, p5398, {}, p5395, p5396, p5397, true);
      v4615 = v4615.clone();
      v4615.scale(p5398, p5400, 1);
      v4615.rotateX(-Math.PI / 2);
      return v4615;
    };
    this.generateSign = function (p5401, p5402, p5403, p5404, p5405, p5406, p5407) {
      var v4616 = GEOS.generatePlane(p5407, p5405, {}, p5402, p5403, p5404, true);
      v4616 = v4616.clone();
      v4616.scale(p5405, p5407, 1);
      v4616.rotateX(-Math.PI / 2);
      return v4616;
    };
    this.generateFlag = function (p5408, p5409) {
      var vParseInt7 = parseInt(p5408.team || 0);
      vParseInt7 = vParseInt7 == -1 ? "n" : vParseInt7 % 2 == 0 ? 0 : 1;
      vThis31.loadObj(p5408, "models/crystal_0.obj", "textures/crystal_" + vParseInt7 + ".png", config.flagScale, "#ffffff", "flagMesh", config.flagOff / 2);
      var v4617 = vThis31.generateObjective(p5408, p5409);
      return v4617;
    };
    this.generateObjective = function (p5410, p5411, p5412) {
      var [v4618, v4619, v4620] = p5410.size;
      var v4621 = GEOS.generateCube([1, 1, 0, 0, 1, 1], p5412 ? v4618 : 1, p5412 ? v4619 : 1, p5412 ? v4620 : 1, {
        scale: p5412 ? 1 : 0,
        amb: p5411,
        useScale: true,
        mat: p5102.MeshBasicMaterial,
        transparent: true,
        depthWrite: false,
        side: 2
      }, true);
      v4621 = v4621.clone();
      if (!p5412) {
        v4621.scale(v4618, p5412 ? v4619 : 5, v4620);
      }
      if (!p5412) {
        v4621.translate(0, -v4619 / 2 + 5 / 2, 0);
      }
      return v4621;
    };
    this.generatePad = function (p5413, p5414) {
      var [v4622, v4623, v4624] = p5413.size;
      var v4625 = p5413.direction < 2 ? Math.min(v4622, v4624) : Math.min(v4623, p5413.direction & 1 ? v4622 : v4624);
      var v4626 = Math.max(v4625 / 10, 0.1);
      vThis31.loadObj(p5413, "models/pad_0.obj", "textures/pad_0.png", 3.6, "#ffffff", "padMesh", p5413.direction < 2 ? -v4623 / 2 + 0.4 : undefined, p5413.direction == 1 ? Math.PI : undefined).then(p5415 => {
        p5415.scale.x = v4626 * 3.6;
        p5415.scale.z = v4626 * 3.6;
        if (p5413.direction >= 2) {
          p5415.rotateZ(-Math.PI / 2);
          p5415.rotateX(Math.PI / 2 * (p5413.direction - 2));
        }
      });
      return new p5102.BufferGeometry();
    };
    this.generateWeapon = function (p5416, p5417) {
      var [v4627, v4628, v4629] = p5416.size;
      var vLN178 = 1;
      let v4630 = GEOS.generateCube([1, 1, 1, 1, 1, 1], v4627, v4628, v4629, {
        scale: 1,
        amb: p5417,
        useScale: true
      }, true);
      v4630 = v4630.clone();
      vThis31.loadObj(p5416, "models/weapons/" + weapons[p5416.weaponId].src + ".obj", "textures/weapons/" + weapons[p5416.weaponId].src + ".png", weapons[p5416.weaponId].scale * vLN178, "#ffffff", "wepMesh", -0.5, -1.6, 0);
      return v4630;
    };
    this.generateSpawn = function (p5418, p5419) {
      var v4631 = p5418.cmpSpwn ? 16776960 : p5418.team == 1 ? 65535 : p5418.team == 2 ? 16711680 : "#ffffff";
      vThis31.loadObj(p5418, "models/spawn_0.obj", "textures/spawn_0.png", 1, v4631, "spwnMesh", -5.5, 0, -((p5418.direction || 0) + 1) * Math.PI / 2);
      let v4632 = GEOS.generateCube([1, 1, 1, 1, 1, 1], 7 + (p5418.spread || 0), 11, 7 + (p5418.spread || 0), {
        scale: 1,
        amb: p5419,
        transparent: true,
        useScale: true,
        depthWrite: false,
        side: 2
      }, true);
      v4632 = v4632.clone();
      if (p5418.previousScale) {
        var v4633 = new p5102.Vector3(7 + (p5418.spread || 0), 11, 7 + (p5418.spread || 0));
        p5418.defaultSize = v4633.toArray();
        p5418.previousScale = new p5102.Vector3();
      }
      return v4632;
    };
    this.generateServerNode = function (p5420, p5421) {
      let v4634 = GEOS.generateCube([1, 1, 1, 1, 1, 1], 5 + (p5420.spread || 0), 5, 5 + (p5420.spread || 0), {
        scale: 0,
        mat: p5102.MeshBasicMaterial,
        amb: p5421,
        useScale: true,
        transparent: true,
        side: 2
      }, true);
      v4634 = v4634.clone();
      if (p5420.previousScale) {
        var v4635 = new p5102.Vector3(5 + (p5420.spread || 0), 5, 5 + (p5420.spread || 0));
        p5420.defaultSize = v4635.toArray();
        p5420.previousScale = new p5102.Vector3();
      }
      return v4634;
    };
    this.generateCubeTool = function (p5422, p5423, p5424) {
      let v4636 = GEOS.generateCube([1, 1, 1, 1, 1, 1], p5424[0], p5424[1], p5424[2], {
        scale: 1,
        scaleM: 0,
        mat: p5102.MeshBasicMaterial,
        amb: p5423,
        useScale: true,
        transparent: true,
        side: 2
      }, true);
      v4636 = v4636.clone();
      return v4636;
    };
    this.generateMysteryBox = function (p5425, p5426) {
      vThis31.loadObj(p5425, "models/weaponbox_0.obj", "textures/weaponbox_0.png", p5425.prefab.scale * 1, "#ffffff", "boxMesh", -1, 0);
      return new p5102.BufferGeometry();
    };
    this.generatePerkMachine = function (p5427, p5428) {
      var v4637 = "perkmachine_0" + (p5427.perk ? "_" + p5427.perk : "");
      vThis31.loadObj(p5427, "models/perkmachine_0.obj", "textures/" + v4637 + ".png", p5427.prefab.scale * 1, "#ffffff", "perkMesh", 0, 0);
      return new p5102.BufferGeometry();
    };
    this.generateKrumMachine = function (p5429, p5430) {
      vThis31.loadObj(p5429, "models/krummachine_0.obj", "textures/krummachine_0.png", p5429.prefab.scale * 1, "#ffffff", "krumMesh", 0, 0);
      return new p5102.BufferGeometry();
    };
    var vA245 = ["#969953", "#646639", "#999153"];
    var vA246 = [{
      name: "Square Oak",
      height: 58,
      scales: [4, 5],
      rar: [6, 7, 8, 9, 10],
      gen: function (p5431, p5432, p5433, p5434, p5435) {
        vF19(p5435.clutterMesh, p5431[0], p5431[1] + p5432 - 1, p5431[2], 90, 100, 90, {
          src: "default",
          shadows: true,
          vNoise: 0.36,
          xR: p5433,
          coat: p5434.cot,
          colr: p5434.col || vA245[p5433 % vA245.length]
        });
      }
    }, {
      name: "Big Oak",
      height: 70,
      scales: [6, 6.2],
      rar: [5],
      gen: function (p5436, p5437, p5438, p5439, p5440) {
        vF19(p5440.clutterMesh, p5436[0], p5436[1] + p5437 - 1, p5436[2], 130, 100, 130, {
          src: "default",
          shadows: true,
          vNoise: 0.3,
          xR: p5438,
          coat: p5439.cot,
          colr: p5439.col || vA245[p5438 % vA245.length]
        });
      }
    }, {
      name: "Tall Italian",
      height: 37,
      scales: [3, 3.2],
      rar: [1, 2, 3, 4],
      gen: function (p5441, p5442, p5443, p5444, p5445) {
        vF19(p5445.clutterMesh, p5441[0], p5441[1] + p5442 - 6, p5441[2], 33, 80, 33, {
          src: "default",
          shadows: true,
          vNoise: 0.3,
          xR: p5443,
          coat: p5444.cot,
          colr: p5444.col || vA245[p5443 % vA245.length]
        });
      }
    }, {
      name: "Honey Oak",
      height: 100,
      scales: [4, 5],
      rar: [0],
      gen: function (p5446, p5447, p5448, p5449, p5450) {
        vF19(p5450.clutterMesh, p5446[0], p5446[1] + p5447 - 1, p5446[2], 55, 56, 55, {
          src: "default",
          shadows: true,
          vNoise: 0.35,
          xR: p5448,
          coat: p5449.cot,
          colr: p5449.col || "#616037"
        });
        vF18(p5450.clutterMesh, p5446[0] + 10, p5446[1] + p5447 / 1.5 + 5, p5446[2], 22, 3, 2, [1, 1, 1, 1, 1, 1], {
          src: "default",
          colr: "#665547",
          zR: 0.4,
          shadows: true,
          amb: 0.5
        });
        vF19(p5450.clutterMesh, p5446[0] + 20, p5446[1] + p5447 / 1.5, p5446[2], 22, 20, 22, {
          src: "default",
          shadows: true,
          vNoise: 0.25,
          coat: p5449.cot,
          colr: p5449.col || "#616037"
        });
      }
    }];
    this.addTREE = function (p5451, p5452, p5453) {
      var v4638 = Math.round(Math.abs((p5451[0] + p5451[2]) % 10));
      var v4639 = null;
      for (var vLN0727 = 0; vLN0727 < vA246.length; ++vLN0727) {
        if (vA246[vLN0727].rar.indexOf(v4638) >= 0) {
          v4639 = vA246[vLN0727];
          break;
        }
      }
      if (v4639) {
        var v4640 = v4639.height - v4638 * 2;
        var v4641 = v4639.scales[v4638 % v4639.scales.length];
        vF18(p5453.clutterMesh, p5451[0], p5451[1], p5451[2], v4641, v4640 + 20, v4641, [1, 1, 0, 0, 1, 1], {
          src: "default",
          colr: "#665547",
          shadows: true,
          amb: 0.5
        });
        v4639.gen(p5451, v4640, v4638, p5452, p5453);
      }
    };
    this.addSTUMP = function (p5454, p5455, p5456) {
      var vLN80 = 80;
      var vLN49 = 4;
      vF18(p5456.clutterMesh, p5454[0], p5454[1], p5454[2], vLN49, vLN80, vLN49, [1, 1, 1, 0, 1, 1], {
        src: "default",
        colr: "#665547",
        shadows: true,
        amb: 0.5
      });
      vF18(p5456.clutterMesh, p5454[0], p5454[1] + 30, p5454[2] + 10, 2, 3, 22, [1, 1, 1, 1, 1, 1], {
        src: "default",
        colr: "#665547",
        yR: -0.5,
        shadows: true,
        amb: 0.5
      });
      vF18(p5456.clutterMesh, p5454[0] + 10, p5454[1] + 50, p5454[2], 22, 3, 2, [1, 1, 1, 1, 1, 1], {
        src: "default",
        colr: "#665547",
        zR: 0.4,
        shadows: true,
        amb: 0.5
      });
    };
    this.addBUSH = function (p5457, p5458, p5459) {
      var v4642 = p5457[3];
      var v4643 = Math.round(Math.abs((p5457[0] + p5457[2]) % 10));
      var v4644 = v4642 == 2 ? 0.5 : 1;
      vF19(p5459.clutterMesh, p5457[0], p5457[1] - v4644 * 6, p5457[2], v4644 * 29, v4644 * 21, v4644 * 28, {
        src: "default",
        colr: p5458.col || "#646639",
        vNoise: 0.3,
        coat: p5458.cot,
        xR: v4643,
        shadows: true
      });
    };
    this.addGRASS = function (p5460, p5461, p5462, p5463) {
      return;
      var v4645 = p5460[3];
      if (p5463) {
        p5463.add(p5460[0], p5460[1] + 4, p5460[2], {
          src: "grass_0",
          colr: p5461.col || "#516621",
          dstVis: 2,
          siz: 9 + Math.random() * 4,
          cnt: 1,
          static: true
        });
      }
    };
    this.addLOOT = function (p5464, p5465, p5466, p5467) {
      var v4646 = Math.round(Math.abs((p5464[0] + p5464[2]) % 3));
      vF18(p5466.clutterMesh, p5464[0] + 6, p5464[1], p5464[2] + 15, 18, 1, 3, [1, 1, 1, 0, 1, 1], {
        src: "default",
        colr: "#665547",
        xR: 0.86,
        shadows: true,
        amb: 0.5
      });
      if (v4646 == 0 || v4646 == 1) {
        vF20(p5466.clutterMesh, p5464[0], p5464[1], p5464[2], 7, 7, 9, {
          src: "default",
          colr: "#9e2b2b",
          shadows: true
        });
      }
      if (v4646 == 2 || v4646 == 1) {
        vF20(p5466.clutterMesh, p5464[0] - 7, p5464[1], p5464[2] + 12, 7, 7, 9, {
          src: "default",
          colr: "#2b769e",
          shadows: true
        });
      }
    };
    var vA247 = [{
      scl: 25,
      hei: 20,
      nois: 0.2,
      col: "#707070"
    }, {
      scl: 50,
      hei: 30,
      nois: 0.3,
      col: "#545454"
    }, {
      scl: 13,
      hei: 10,
      nois: 0.15,
      col: "#707070",
      noCol: true
    }, {
      scl: 10,
      hei: 10,
      nois: 0.1,
      col: "#545454",
      noCol: true
    }];
    this.addROCK = function (p5468, p5469, p5470) {
      var v4647 = p5468[1] - 7;
      var v4648 = Math.round(Math.abs((p5468[0] + p5468[2]) % 10));
      var v4649 = vA247[v4648 % vA247.length];
      vF19(p5470.clutterMesh, p5468[0], v4647, p5468[2], v4649.scl, v4649.hei, v4649.scl, {
        src: "default",
        colr: v4649.col,
        vNoise: v4649.nois,
        noAmb: true,
        coat: p5469.cot,
        shadows: true
      });
    };
    this.addTerrObj = function (p5471, p5472, p5473, p5474) {
      var vO126 = {
        col: null,
        cot: null
      };
      var v4650 = p5473.BIOME_INDEXES[p5471[3]];
      var v4651 = p5473.MAP_OBJS[p5472];
      if (v4651 && v4650) {
        if (v4651.biomeCoats && v4651.biomeCoats[v4650]) {
          vO126.cot = v4651.biomeCoats[v4650];
        }
        if (v4651.biomeCols && v4651.biomeCols[v4650]) {
          vO126.col = v4651.biomeCols[v4650][UTILS.randInt(0, v4651.biomeCols[v4650].length - 1)];
        }
      }
      vThis31["add" + p5472](p5471, vO126, p5473, p5474);
    };
    let vF21 = p5475 => ({
      src: p5475
    });
    this.getImageTexture = p5476 => {
      var v4652 = new p5102.Texture(p5476);
      v4652.wrapS = p5102.RepeatWrapping;
      v4652.wrapT = p5102.RepeatWrapping;
      v4652.repeat.set(1, 1);
      v4652.minFilter = p5102.NearestFilter;
      v4652.magFilter = p5102.NearestFilter;
      v4652.needsUpdate = true;
      return v4652;
    };
    var vA248 = [];
    this.loadTexturePrefab = function (p5477, p5478 = null) {
      if (p5478.prefab.name == "LEADERBOARD") {
        var v4653 = Array((p5478.leaderResults || 25) * 2).fill().map((p5479, p5480) => p5480 % 2 == 0 ? "Player " + Math.round((p5480 + 1) / 2) : UTILS.randInt(0, 10000));
        p5478.defaultMaterial.map = vThis31.getImageTexture(UTILS.createLeaderText(p5478.size[0], p5478.size[2], v4653, {
          fontSize: p5478.fsize || 10,
          fcolr: p5478.fcolor || "#000",
          bcolr: p5478.bcolor || "#fff",
          noBVis: !p5478.backVisible,
          leaderType: "score",
          leaderTypeCust: "",
          leaderOrder: 0,
          leaderResults: p5478.leaderResults,
          noSCF: !!p5478.noSCF
        }));
      } else if (p5478.prefab.hasText) {
        p5478.defaultMaterial.map = vThis31.getImageTexture(UTILS.createCanvasText(p5478.size[0], p5478.size[2], p5478.text || "Hello World", p5478.fsize || 10, p5478.fcolor || "#000", p5478.bcolor || "#fff", !p5478.backVisible, p5478.tAlign || 0, p5478.ocolor || "#111111", p5478.othick, !!p5478.noSCF));
      } else if (p5478.texturePrefab && p5478.texturePrefab.src || p5478.assetTexture && p5478.prefab.assetTextures || p5478.sprayTexture && p5478.prefab.sprayTexture) {
        let v4654 = p5478.sprayTexture && p5478.prefab.sprayTexture;
        let v4655 = p5478.assetTexture && p5478.prefab.assetTextures;
        let v4656 = !!v4655 && !!(p5478.assetTexture + "").includes("v") && (p5478.assetTexture + "").replace("v", "");
        let v4657 = v4655 ? vF21(v4656 ? v4656 + "/video" : p5478.assetTexture + "/texture") : v4654 ? vF21("sprays/" + store.skins[p5478.sprayTexture].id) : vThis31.getTextureByName(p5477);
        v4657 = p5478.objType == "BILLBOARD" ? vF21("pubs/b_" + (parseInt(p5478.poster) ? UTILS.limitMM(parseInt(p5478.poster), 1, config.billboards.length - 1) : UTILS.randInt(1, config.billboards.length - 1))) : v4657;
        v4657 = p5478.objType == "FLAG" ? vF21("zone_r_1") : v4657;
        v4657 = p5478.objType == "OBJECTIVE" ? vF21("objective_4") : v4657;
        v4657 = p5478.objType == "DOMINATION_ZONE" ? vF21("objective_4") : v4657;
        v4657 = p5478.objType == "BOMB_SITE" ? vF21("objective_b") : v4657;
        v4657 = p5478.objType == "LIGHT_CONE" ? vF21("lightcone_" + (p5478.fullcone ? 1 : 0)) : v4657;
        v4657 = p5478.objType == "LIGHT_BAR" ? vF21("lightcone_1") : v4657;
        v4657 = p5478.objType == "CAMERA" ? vF21("spectatecam_0") : v4657;
        v4657 = p5478.objType == "RUNE" ? vF21("rune_0") : v4657;
        v4657 = p5478.objType == "PRIZE_WHEEL" ? vF21("wheel_0") : v4657;
        v4657 = p5478.objType == "SERVER_NODE" ? vF21("servernode_1") : v4657;
        v4657 = p5478.objType == "MAP_ANCHOR" ? vF21("check_0") : v4657;
        if (v4657.src == "default") {
          return p5478.defaultMaterial.map = undefined;
        }
        var v4658 = v4657.variants && p5478.texVar && v4657.variants[p5478.texVar] ? "_" + v4657.variants[p5478.texVar].id : "";
        var v4659 = v4657.src + v4658;
        var v4660 = p5478.frameCount || 0;
        var v4661 = Math.min(10, v4660);
        var v4662 = v4660 > 10 ? Math.ceil(v4660 / 10) : 0;
        if (vA248[v4659]) {
          p5478.defaultMaterial.map = vA248[v4659].clone();
          p5478.defaultMaterial.map.needsUpdate = true;
          p5478.defaultMaterial.map.offset.x = parseFloat(p5478.texOffX) || 0;
          p5478.defaultMaterial.map.offset.y = parseFloat(p5478.texOffY) || 0;
          p5478.defaultMaterial.map.repeat.set(v4660 ? 1 / v4661 : 1, v4662 ? 1 / v4662 : 1);
          p5478.defaultMaterial.map.rotation = UTILS.toRad(p5478.texRot || 0);
          p5478.defaultMaterial.needsUpdate = true;
        } else if (v4659.startsWith("custom_")) {
          var v4665 = new p5102.Texture(vThis31.missingTexture);
          v4665.wrapS = p5102.RepeatWrapping;
          v4665.wrapT = p5102.RepeatWrapping;
          v4665.repeat.set(1, 1);
          v4665.minFilter = v4657.filter || p5102.NearestFilter;
          v4665.magFilter = v4657.filter || p5102.NearestFilter;
          v4665.offset.x = parseFloat(p5478.texOffX) || 0;
          v4665.offset.y = parseFloat(p5478.texOffY) || 0;
          v4665.rotation = UTILS.toRad(p5478.texRot || 0);
          v4665.needsUpdate = true;
          vA248[v4659] = v4665;
          p5478.defaultMaterial.map = v4665;
          p5478.defaultMaterial.needsUpdate = true;
        } else if (v4656) {
          var v4664 = document.getElementById("video_" + v4656);
          if (!v4664) {
            v4664 = document.createElement("video");
            v4664.crossOrigin = "anonymous";
            v4664.id = "video_" + v4656;
            v4664.src = UTILS.userAssetsUrl(v4659 + ".mp4");
            v4664.style.display = "none";
            document.body.appendChild(v4664);
            v4664.loop = true;
            v4664.volume = 0;
            v4664.play();
          }
          var v4665 = new p5102.VideoTexture(v4664);
          v4665.wrapS = p5102.RepeatWrapping;
          v4665.wrapT = p5102.RepeatWrapping;
          v4665.repeat.set(1, 1);
          v4665.minFilter = v4657.filter || p5102.NearestFilter;
          v4665.magFilter = v4657.filter || p5102.NearestFilter;
          v4665.offset.x = parseFloat(p5478.texOffX) || 0;
          v4665.offset.y = parseFloat(p5478.texOffY) || 0;
          v4665.rotation = UTILS.toRad(p5478.texRot || 0);
          v4665.needsUpdate = true;
          vA248[v4659] = v4665;
          p5478.defaultMaterial.map = v4665;
          p5478.defaultMaterial.needsUpdate = true;
        } else {
          v4523.load(v4655 ? UTILS.userAssetsUrl(v4659 + ".png", null, null, true) : UTILS.assetsUrl("/textures/" + v4659 + ".png"), p5481 => {
            p5481.wrapS = p5102.RepeatWrapping;
            p5481.wrapT = p5102.RepeatWrapping;
            p5481.repeat.set(v4660 ? 1 / v4661 : 1, v4662 ? 1 / v4662 : 1);
            p5481.minFilter = v4657.filter || p5102.NearestFilter;
            p5481.magFilter = v4657.filter || p5102.NearestFilter;
            p5481.offset.x = parseFloat(p5478.texOffX) || 0;
            p5481.offset.y = parseFloat(p5478.texOffY) || 0;
            p5481.rotation = UTILS.toRad(p5478.texRot || 0);
            p5481.needsUpdate = true;
            vA248[v4659] = p5481;
            p5478.defaultMaterial.map = p5481;
            p5478.defaultMaterial.needsUpdate = true;
          }, undefined, function (p5482) {
            var v4666 = new p5102.Texture(vThis31.missingTexture);
            v4666.wrapS = p5102.RepeatWrapping;
            v4666.wrapT = p5102.RepeatWrapping;
            v4666.repeat.set(1, 1);
            v4666.minFilter = v4657.filter || p5102.NearestFilter;
            v4666.magFilter = v4657.filter || p5102.NearestFilter;
            v4666.offset.x = parseFloat(p5478.texOffX) || 0;
            v4666.offset.y = parseFloat(p5478.texOffY) || 0;
            v4666.rotation = UTILS.toRad(p5478.texRot || 0);
            v4666.needsUpdate = true;
            vA248[v4659] = v4666;
            p5478.defaultMaterial.map = v4666;
            p5478.defaultMaterial.needsUpdate = true;
          });
        }
      } else {
        p5478.defaultMaterial.map = undefined;
      }
    };
    this.missingTexture = new Image();
    this.missingTexture.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAgMAAAAP2OW3AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAxQTFRF/wDbAAAAAAAA/wDbC5gN/AAAAAR0Uk5T/P/9/02rixUAAAAMSURBVHicYxBg2AAAAOQAwSeo6FcAAAAASUVORK5CYII=";
  }
};